export const isValidSize = (value: string): boolean => ['small', 'medium', 'large'].includes(value);
